import { lazy, Suspense, useState, useCallback } from 'react';
import FullWidthModal from '@components/common/Modal/FullWidthModal';

const TogoCreateCheckModalV2 = lazy(() =>
  import('@components/checkListV2/Modals/togoModal')
);

export const useTogoModal = ({
  serverAppTheme,
  orderingPortraitOrientation,
  isTogo,
  isLandScape,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onOpenTogo = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const jsx = !isModalOpen ? null : (
    <Suspense fallback={null}>
      <FullWidthModal isOpen isModalCenter className="h-100">
        <TogoCreateCheckModalV2
          serverAppTheme={serverAppTheme}
          orderingPortraitOrientation={orderingPortraitOrientation}
          isTogo={isTogo}
          isLandScape={isLandScape}
          onCloseModal={closeModal}
        />
      </FullWidthModal>
    </Suspense>
  );

  return { onOpenTogo, jsx };
};
